export const queryKeys = {
  ATMOS_CONFIG: 'ATMOS_CONFIG'
};
